import {
  CREATE_PURCHASE_RETURN_REQUESTED,
  CREATE_PURCHASE_RETURN_SUCCESS,
  CREATE_PURCHASE_RETURN_ERRORED,
  GET_PURCHASE_RETURN_REQUESTED,
  GET_PURCHASE_RETURN_SUCCESS,
  GET_PURCHASE_RETURN_ERRORED,
  GET_PURCHASE_RETURN_DETAILS_REQUESTED,
  GET_PURCHASE_RETURN_DETAILS_SUCCESS,
  GET_PURCHASE_RETURN_DETAILS_ERRORED,
  UPDATE_PURCHASE_RETURN_REQUESTED,
  UPDATE_PURCHASE_RETURN_SUCCESS,
  UPDATE_PURCHASE_RETURN_ERRORED,
  DELETE_PURCHASE_RETURN_REQUESTED,
  DELETE_PURCHASE_RETURN_SUCCESS,
  DELETE_PURCHASE_RETURN_ERRORED,
} from "../constant/action-types";

import axios from "axios";

import { showSnackbar } from "../../../../actions/action-snackbar";

import configureStore from "../../../../store/configureStore";

const store = configureStore();

export const create_purchase_return_requested = () => ({
  type: CREATE_PURCHASE_RETURN_REQUESTED,
});

export const create_purchase_return_success = () => ({
  type: CREATE_PURCHASE_RETURN_SUCCESS,
});

export const create_purchase_return_errored = (error) => ({
  type: CREATE_PURCHASE_RETURN_ERRORED,
  error,
});

export const get_purchase_return_requested = () => ({
  type: GET_PURCHASE_RETURN_REQUESTED,
});

export const get_purchase_return_success = (payload) => ({
  type: GET_PURCHASE_RETURN_SUCCESS,
  payload,
});

export const get_purchase_return_errored = (error) => ({
  type: GET_PURCHASE_RETURN_ERRORED,
  error,
});

export const get_purchase_return_details_requested = () => ({
  type: GET_PURCHASE_RETURN_DETAILS_REQUESTED,
});

export const get_purchase_return_details_success = (payload) => ({
  type: GET_PURCHASE_RETURN_DETAILS_SUCCESS,
  payload,
});

export const get_purchase_return_details_errored = (error) => ({
  type: GET_PURCHASE_RETURN_DETAILS_ERRORED,
  error,
});

export const update_purchase_return_requested = () => ({
  type: UPDATE_PURCHASE_RETURN_REQUESTED,
});

export const update_purchase_return_success = (payload) => ({
  type: UPDATE_PURCHASE_RETURN_SUCCESS,
  payload,
});

export const update_purchase_return_errored = (error) => ({
  type: UPDATE_PURCHASE_RETURN_ERRORED,
  error,
});
export const delete_purchase_return_requested = () => ({
  type: DELETE_PURCHASE_RETURN_REQUESTED,
});

export const delete_purchase_return_success = (payload) => ({
  type: DELETE_PURCHASE_RETURN_SUCCESS,
  payload,
});

export const delete_purchase_return_errored = (error) => ({
  type: DELETE_PURCHASE_RETURN_ERRORED,
  error,
});

export const create_purchase_return =
  (payload, activeOuid) => async (dispatch) => {
    dispatch(create_purchase_return_requested());
    console.log(`Create purchase return`);
    console.log("activeOuid", activeOuid);
    const { accountsApiEndpoint, credentials } = store.getState().jwt.api;
    if (accountsApiEndpoint && credentials) {
      const jwt = `${credentials.idToken.jwtToken}`;
      let url = `${accountsApiEndpoint}/purchasereturns`;
      const method = "post";
      const axiosHeader = {
        headers: {
          Authorization: jwt,
          "x-ouid": activeOuid,
        },
      };
      return axios[method](url, payload, axiosHeader)
        .then((response) => {
          console.log("purchase return created successfully");
          dispatch(
            showSnackbar("purchase return created successfully", "success")
          );
          dispatch(create_purchase_return_success(response));
          dispatch(get_purchase_return(activeOuid));
        })
        .catch((err) => {
          console.log("purchase return creation Failed");
          // console.error('ErrorLog : ', JSON.stringify(err));
          dispatch(showSnackbar("purchase return creation Failed", "error"));
          dispatch(create_purchase_return_errored(err));
        });
    }
    return null;
  };

export const get_purchase_return = (activeOuid) => async (dispatch) => {
  dispatch(get_purchase_return_requested());
  const { accountsApiEndpoint, credentials } = store.getState().jwt.api;
  console.log(`accountsApiEndpoint`, accountsApiEndpoint);
  console.log(`credentials`, credentials);

  if (accountsApiEndpoint && credentials) {
    const jwt = `${credentials.idToken.jwtToken}`;
    let url = `${accountsApiEndpoint}/purchasereturns`;

    const method = "get";
    const axiosHeader = {
      headers: {
        Authorization: jwt,
        "x-ouid": activeOuid,
      },
    };
    return axios[method](url, axiosHeader)
      .then((response) => {
        console.log("Get purchase return Success", response.data);
        dispatch(get_purchase_return_success(response.data.items));
      })
      .catch((err) => {
        console.log("Get purchase return Failed");
        if (err.response) {
          var data = err.response.data;
          dispatch(showSnackbar(data.error, "error"));
        } else {
          dispatch(showSnackbar("Get purchase return Failed", "error"));
        }
        dispatch(get_purchase_return_errored(err));
      });
  }
  return null;
};

export const get_purchase_return_details =
  (purchaseReturnId, activeOuid) => async (dispatch) => {
    dispatch(get_purchase_return_details_requested());
    const { accountsApiEndpoint, credentials } = store.getState().jwt.api;
    console.log(`accountsApiEndpoint`, accountsApiEndpoint);
    console.log(`credentials`, credentials);

    if (accountsApiEndpoint && credentials) {
      const jwt = `${credentials.idToken.jwtToken}`;
      let url = `${accountsApiEndpoint}/purchasereturns/id/${purchaseReturnId}`;

      const method = "get";
      const axiosHeader = {
        headers: {
          Authorization: jwt,
          "x-ouid": activeOuid,
        },
      };
      return axios[method](url, axiosHeader)
        .then((response) => {
          console.log("Get purchase return Success", response.data);
          dispatch(get_purchase_return_details_success(response.data));
        })
        .catch((err) => {
          console.log("Get purchase return Failed");
          if (err.response) {
            var data = err.response.data;
            dispatch(showSnackbar(data.error, "error"));
          } else {
            dispatch(showSnackbar("Get purchase return Failed", "error"));
          }
          dispatch(get_purchase_return_details_errored(err));
        });
    }
    return null;
  };

export const update_purchase_return =
  (payload, purchaseReturnId, activeOuid) => async (dispatch) => {
    dispatch(update_purchase_return_requested());
    console.log(`update_purchase_return`);

    const { accountsApiEndpoint, credentials } = store.getState().jwt.api;
    if (accountsApiEndpoint && credentials) {
      const jwt = `${credentials.idToken.jwtToken}`;
      let url = `${accountsApiEndpoint}/purchasereturns/id/${purchaseReturnId}`;
      const { activeOuid, activeOuidChain } = store.getState().permission;
      const method = "put";
      const axiosHeader = {
        headers: {
          Authorization: jwt,
          "x-ouid": activeOuid,
          "x-ouidchain": activeOuidChain,
        },
      };
      return axios[method](url, payload, axiosHeader)
        .then((response) => {
          console.log("purchase return Updation Success");
          dispatch(
            showSnackbar("purchase return Updated Successfully", "success")
          );
          dispatch(update_purchase_return_success());
          dispatch(get_purchase_return(activeOuid));
        })
        .catch((err) => {
          console.log("purchase return updation Failed");
          dispatch(showSnackbar("purchase return updation Failed", "error"));
          dispatch(update_purchase_return_errored(err));
        });
    }
    return null;
  };

export const delete_purchase_return =
  (activeOuid, purchaseReturnId) => async (dispatch) => {
    dispatch(delete_purchase_return_requested());
    console.log(`delete_note`);
    const { accountsApiEndpoint, credentials } = store.getState().jwt.api;
    if (accountsApiEndpoint && credentials) {
      const jwt = `${credentials.idToken.jwtToken}`;
      let url = `${accountsApiEndpoint}/purchasereturns/id/${purchaseReturnId}`;
      const method = "delete";
      const axiosHeader = {
        headers: {
          Authorization: jwt,
          "x-ouid": activeOuid,
        },
      };
      return axios[method](url, axiosHeader)
        .then((response) => {
          console.log("Delete purchase return Success");
          dispatch(
            showSnackbar("purchase return deleted successfully", "success")
          );
          dispatch(delete_purchase_return_success());
          dispatch(get_purchase_return("", activeOuid));
        })
        .catch((err) => {
          if (err.response) {
            console.log(
              "Delete purchase return Failed :",
              JSON.stringify(err.response.data)
            );
            var data = err.response.data;
            dispatch(showSnackbar(data.error, "error"));
          } else {
            dispatch(showSnackbar("Delete purchase return", "error"));
          }
          dispatch(delete_purchase_return_errored(err));
        });
    }
    return null;
  };
